function isEmptyStr(str) {
    return (str.length === 0 || !str.trim());
}

function isValidPhone(mobile) {
    return /^1[3-9]\d{9}$/.test(mobile);
}

export {
    isEmptyStr,
    isValidPhone
}